export default __webpack_public_path__ + "static/media/701.9977c0ab.svg";